import { createTheme } from '@mui/material/styles';


export const theme = createTheme({
  palette: {
    primary: {
      main: '#133385',
      light: '#144bba',
      dark: '#081b43',
    },
    secondary: {
      main: '#E10734',
      light: '#ff1f47',
      dark: '#9e0222',
    }
  },
  components:{
    MuiButton: {
      styleOverrides: {
        root:{
          borderRadius: 5
        }
      }
    }
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif', // Establece Roboto como la fuente principal
  },
});